angular.module('CarsSaraBo').factory('RangeDiscountService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/rangeDiscount/:oid', 
    { 
	  companyOid : '@companyOid',
	  oid : '@oid' 
    },
    {
    	update : { method: 'PUT' },
    	getAll:  {method:'GET', isArray:true},
    	save: {method:'POST'}
    }
  )}
]);


angular.module('CarsSaraBo').factory('RangeDiscountServiceAll', ['$resource', function($resource) {
	 return $resource('../rest/company/:companyOid/rangeDiscount/all', 
	    { 
		  companyOid : '@companyOid',
	    },
	    {
	    	remove : { method: 'DELETE'},
	    }
	 )}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/rangeDiscount_service.js
// module id = 860
// module chunks = 3